import InitCKEditor from "./JavaScript/CKEditor";
import InitLazyLoad from "./JavaScript/LazyLoad";
import InitScrollReveal from "./JavaScript/ScrollReveal";
import InitMenu from "./JavaScript/Menu";
import InitHeaderScroll from "./JavaScript/HeaderScroll";
import InitGradientScroll from "./JavaScript/GradientScroll";
import InitAbxLexikon from "./JavaScript/AbxLexikon";
import InitTeaser from "./JavaScript/Teaser";
import InitCarouselCards from "./JavaScript/CarouselCards";
import InitImageTextTileSlider from "./JavaScript/ImageTextTileSlider";
import InitProcessGraphic from "./JavaScript/ProcessGraphic";
import InitForms from "./JavaScript/Forms";
import InitNumberInput from "./JavaScript/NumberInput";
import InitTooltip from "./JavaScript/Tooltip";
import InitShoppingCart from "./JavaScript/ShoppingCart";
import InitProductList from "./JavaScript/ProductList";
import InitSearch from "./JavaScript/Search";
import InitSearchCategoryAccordion from "./JavaScript/SearchCategoryAccordion";
import InitDialog from "./JavaScript/PopUp/Dialog";
import InitSondernavigation from "./JavaScript/Sondernavigation";
import InitLandkarte from "./JavaScript/Landkarte";
import InitPipelineModule from "./JavaScript/PipelineModule";
import InitAnsprechpartnerModule from "./JavaScript/AnsprechpartnerModule";
import InitColorBoxSlider from "./JavaScript/ColorBoxSlider";
import InitImageGallery from "./JavaScript/ImageGallery";
import InitImageSlider from "./JavaScript/ImageSlider";
import InitBrandSlider from "./JavaScript/BrandSlider";
import InitTeaserTextBox from "./JavaScript/TeaserTextBox";
import InitHistoryTimeline from "./JavaScript/HistoryTimeline";
import InitAccordion from "./JavaScript/Accordion";
import { checkForDialog, checkForDocCheckPopUp, checkForCaptcha, checkForSlimSelect } from "./JavaScript/AsyncImportChecks";

// https://stackoverflow.com/questions/57776001/how-to-detect-ipad-pro-as-ipad-using-javascript
function isIpadOS() {
    return navigator.maxTouchPoints &&
        navigator.maxTouchPoints > 2 &&
        /MacIntel/.test(navigator.platform);
}

function checkForTouchDevice() {
    if ('ontouchstart' in window || 'ontouch' in window || /iPad|iPhone|iPod/.test(navigator.platform) || isIpadOS()) {
        document.body.classList.add('touch-device');
    } else {
        document.body.classList.add('non-touch-device');
    }
}

document.addEventListener('DOMContentLoaded', function () {
    checkForTouchDevice();
    InitCKEditor();
    InitLazyLoad();
    InitScrollReveal();
    InitMenu();
    InitHeaderScroll();
    InitGradientScroll();
    InitAbxLexikon();
    InitTooltip();
    InitTeaser();
    InitCarouselCards();
    InitImageTextTileSlider();
    InitProcessGraphic();
    InitForms();
    InitShoppingCart();
    // InitNumber must be after InitShoppingCart
    InitNumberInput();
    InitProductList();
    InitSearch();
    InitSearchCategoryAccordion();
    InitDialog();
    InitSondernavigation();
    InitLandkarte();
    InitPipelineModule();
    InitAnsprechpartnerModule();
    InitColorBoxSlider();
    InitImageGallery();
    InitImageSlider();
    InitBrandSlider();
    InitTeaserTextBox();
    InitHistoryTimeline();
    InitAccordion();

    // async imported code
    checkForDialog();
    checkForDocCheckPopUp();
    checkForCaptcha();
    checkForSlimSelect();
});
